// The Waiter screen owns the menu data; the menu category picker lives in the
// global bar. They talk through these two window events (same pattern as the
// other bar/page pairs), so the bar needs no props from the kiosk screen.

/** Waiter -> bar: the categories on offer and the active one (null when the screen unmounts). */
export const WAITER_MENU_TABS_EVENT = 'waiter:menu-tabs';
/** Bar -> Waiter: the category the user picked. */
export const WAITER_MENU_TAB_SET_EVENT = 'waiter:menu-tab-set';

export interface WaiterMenuTabsState {
  tabs: string[];
  active: string;
}
